import FollowUpSettings from "./FollowUpSettings";
import { PageLayout } from "@/layouts";
import { VStack } from "@/components/core";

const FollowUpSettingsPage = () => {
  return (
    <PageLayout maxWidth="lg" padding="md" className="design-page-gradient">
      <VStack gap="lg">
        <div className="fade-in-up">
          <h1 className="text-3xl md:text-4xl font-bold design-text-primary mb-token-sm">
            <span className="gradient-text">Follow-Up</span> Nachrichten
          </h1>
          <p className="design-text-secondary">
            Erhalte liebevolle Nachrichten von deinen Charakteren zwischen euren Chats
          </p>
        </div>

        <FollowUpSettings />
      </VStack>
    </PageLayout>
  );
};

export default FollowUpSettingsPage;
